import navigation from 'utils/navigation'

const pageNotFoundHandler = () => {
  navigation.push('/404')
}

export default pageNotFoundHandler
